import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.managementService


//根据条件查询菜单列表(包括子菜单)
export function getselectMenuListAndChildrenByParam(data) {
    return request({
        url: serviceName + `/menu/list`,
        method: 'post',
        data:data
    })
}


//新增数据
export function postTbMenuInsertAdd(data) {
    return request({
        url: serviceName + `/menu/add`,
        method: 'post',
        data: data
    })
}


//修改数据
export function postTbMenuUpdate(data) {
    return request({
        url: serviceName + `/menu/update`,
        method: 'post',
        data: data
    })
}


//删除数据
export function postTbMenuDelete(data) {
    return request({
        url: serviceName + `/tbMenu/delete`,
        method: 'post',
        data: data
    })
}


//通过主键查询单条数据
export function getTbMenuIDdep(id) {
    return request({
        url: serviceName + `/tbMenu/${id}`,
        method: 'get',
    })
}


//根据条件查询菜单列表
export function selectMenuListByParam(data) {
    return request({
        url: serviceName + `/tbMenu/selectMenuListByParam`,
        method: 'post',
        data:data
    })
}
